import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PreviewModal.css';

const PreviewModal = ({ isOpen, onClose, template }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !template) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <i className="fa fa-times"></i>
        </button>

        <div className="modal-header">
          <h2>{template.name}</h2>
          <span className="modal-badge" style={{ backgroundColor: template.color }}>
            {template.category}
          </span>
        </div>

        <div className="modal-body">
          <div className="modal-preview">
            <div
              className="modal-preview-placeholder"
              style={{
                background: `linear-gradient(135deg, ${template.color}22 0%, ${template.color}11 100%)`,
                borderTop: `4px solid ${template.color}`
              }}
            >
              <i className="fa fa-file-alt" style={{ color: template.color }}></i>
              <span>Template Preview</span>
              <p className="preview-note">Click "View Live Form" to see the actual form</p>
            </div>
          </div>

          <div className="modal-details">
            <h3>Description</h3>
            <p>{template.description}</p>

            <h3>Key Features</h3>
            <ul className="modal-features-list">
              {template.features.map((feature, idx) => (
                <li key={idx}>
                  <i className="fa fa-check-circle" style={{ color: template.color }}></i>
                  {feature}
                </li>
              ))}
            </ul>

            <h3>Best Suited For</h3>
            <div className="modal-tags">
              {template.suitedFor?.map((item, idx) => (
                <span key={idx} className="modal-tag" style={{ borderColor: template.color, color: template.color }}>
                  {item}
                </span>
              ))}
            </div>

            <h3>Technical Specifications</h3>
            <div className="modal-specs">
              <div className="spec-item">
                <i className="fa fa-mobile-alt"></i>
                <span>Fully Responsive</span>
              </div>
              <div className="spec-item">
                <i className="fa fa-paint-brush"></i>
                <span>Customizable Colors</span>
              </div>
              <div className="spec-item">
                <i className="fa fa-bolt"></i>
                <span>Fast Loading</span>
              </div>
              <div className="spec-item">
                <i className="fa fa-shield-alt"></i>
                <span>Secure API</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Link
            to={`/form/${template.clientId}`}
            className="btn-modal-primary"
            style={{ backgroundColor: template.color }}
          >
            <i className="fa fa-eye"></i>
            View Live Form
          </Link>
          <button className="btn-modal-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
